module.exports = __webpack_public_path__ + "fonts/Barlow-Regular.bae4c7f.woff";